import { render, staticRenderFns } from "./MessageIcon.vue?vue&type=template&id=667ce3e4&"
import script from "./MessageIcon.vue?vue&type=script&lang=ts&"
export * from "./MessageIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports